export function getRandomNrBetween(min: number, max: number, integer = false) {
  if (integer) {
    const number = Math.random() * (max - min + 1) + min
    return Math.floor(number)
  } else {
    return Math.random() * (max - min) + min
  }
}

export function getRandomValueAround(middle: number, spread: number, min: number, max: number) {
  const minVal = Math.max(min, middle - spread)
  const maxVal = Math.min(max, middle + spread)
  return getRandomNrBetween(minVal, maxVal, false)
}

export function calculateRandomValueWithPercentage(value: number, radomnessPercentage: number, min: number, max: number) {
  const spread = value * (radomnessPercentage / 100)
  return getRandomValueAround(value, spread, min, max)
}


